import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { btnPrimary, inputCls } from "./ui";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email.trim().toLowerCase(), password); navigate("/admin"); } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F5F0E8]" data-testid="admin-login-page">
      <div className="hidden lg:flex relative grain bg-[#39251D] items-end p-14">
        <div className="relative">
          <Logo light size="footer" testId="admin-login-logo" />
          <p className="mt-6 font-serif italic text-2xl text-[#D5B98C] max-w-sm">Una nuova identità, le stesse radici, la stessa passione.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div className="lg:hidden mb-8"><Logo testId="admin-login-logo-mobile" /></div>
          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#956842]">Area riservata</div>
            <h1 className="font-serif text-4xl text-[#39251D] mt-2">Accesso amministratori</h1>
          </div>
          <input data-testid="admin-login-email" type="email" inputMode="email" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="admin-login-password" type="password" autoComplete="current-password" autoCapitalize="none" autoCorrect="off" spellCheck={false} required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          {error && <p data-testid="admin-login-error" className="text-sm text-[#8a2f22]">{error}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className={`${btnPrimary} w-full py-3.5`}>{busy ? "Accesso…" : "Accedi"}</button>
        </form>
      </div>
    </div>
  );
}
